const scoreFormatter = new Intl.NumberFormat("en", { notation: "compact" });
const positionFormatter = new Intl.PluralRules("en", { type: "ordinal" });

const formatScore = (score) => scoreFormatter.format(score);
const formatPosition = (pos) =>
  pos + { one: "st", two: "nd", few: "rd", other: "th" }[positionFormatter.select(pos)];

export { formatScore, formatPosition };
